module.exports = __webpack_public_path__ + "static/06-39dc1a8f1db92ca0f79c2d4d49b3f6e7.jpg";